var $ = require('jquery');

window.GenericUtilities = {
    isRTL: function () {
        var direction = $('html').attr('data-dir'),
            isRtl = false;

        if (direction == 'rtl') {
            isRtl = true;
        }
        return isRtl;
    },

    getCookieByName: function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    setSessionVariables: function (url, cookieName, id) {
        if (cookieName !== 'undefined' && cookieName != '') {
            $.ajax({
                url: '/api/sitecore/sessiondata/storesesiondata',
                type: 'POST',
                data: {
                    urlParams: url,
                    cookieName: cookieName,
                    itemContext: id
                }
            });
        }
    },

    getQueryString: function (key) {
        var paramsArray = window.location.search.substr(1).split('&');
        let params = {};

        for (let i = 0; i < paramsArray.length; ++i) {
            let param = paramsArray[i]
                .split('=', 2);

            if (param.length !== 2)
                continue;

            params[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " "));
        }

        return params[key];
    },

    createFileUploadIframe: function (confirmationBody, url) {
        if (url) {
            // Crowe.Forms expects lowercase urls
            url = url.toLowerCase();
        }
        
        let iframeWrapper = document.createElement('div');
        iframeWrapper.setAttribute('style', 'display: flex; width: 100%; height: 100%; overflow: hidden;');
        iframeWrapper.classList.add("file-upload-iframe");
        iframeWrapper.classList.add('padding-top-16');
        let iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.setAttribute('id', 'fileUpload');
        if (url.includes('ds=1')) {
            iframe.setAttribute('style', 'border: 2px solid #DFDFDF; border-radius: 10px; width: 100%;');
        } else {
            iframe.setAttribute('style', 'border: 2px solid #DFDFDF; width: 100%;');
        }        
        iframeWrapper.appendChild(iframe);
        confirmationBody.appendChild(iframeWrapper);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        let uploadOrigin = new URL(url).origin;

        window.addEventListener('message', (event) => {
            if (event.origin == uploadOrigin) {
                window.GenericUtilities.resizeIframe(document.getElementById('fileUpload'), (event.data + 64));
            }
        }, uploadOrigin)
    },

    resizeIframe: function (el, padding) {
        if (el) {
            if (padding && padding !== 'undefined' && padding !== '') {
                el.height = padding + "px";
            }
        }
    }
}